import { Box, Button, Text, Heading } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function DescriptionCardUserGuide({
    ImgUrl,
    description,
    description2,
    textButton,
    textButton2,
    title,
    onClick,
    onPreview,
    isDownloadDisabled,
    isPreviewDisabled,
    variant = "pdf", // "pdf" | "video-portal" | "video-single"
}) {
    return (
        <Box
            position="relative"
            height="270px"
            width="100%"
            maxW="430px"
            bgImage={ImgUrl}
            bgSize="cover"
            bgPosition="center"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            _hover={{ boxShadow: "dark-lg" }}
            borderRadius="lg"
            overflow="hidden"
            p={4}
            transition="transform 0.3s ease"
            margin="0 auto"
        >
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="rgba(0, 0, 0, 0.7)"
            />

            <Box
                position="relative"
                color="white"
                textAlign="center"
                zIndex={1}
                display="flex"
                flexDirection="column"
                height="100%"
            >
                <Box flex="1">
                    <Heading
                        as="h2"
                        size="md"
                        mb={3}
                        fontWeight="bold"
                        noOfLines={2}
                        pt={3}
                    >
                        {title}
                    </Heading>
                    <Text fontSize="sm" mb={4} noOfLines={3} px={4}>
                        {description}
                    </Text>
                    {/* <Text fontSize="sm" mb={4} noOfLines={3} px={4}>
                        {description2}
                    </Text> */}
                </Box>

                <Box display="flex" justifyContent="center" gap={4} mb={2}>
                    {variant === "pdf" && (
                        <>
                            <Button
                                colorScheme="green"
                                size="sm"
                                fontWeight="bold"
                                onClick={onClick}
                                isDisabled={isDownloadDisabled}
                            >
                                {textButton}
                            </Button>
                            <Button
                                colorScheme="green"
                                size="sm"
                                fontWeight="bold"
                                onClick={onPreview}
                                isDisabled={isPreviewDisabled}
                            >
                                {textButton2}
                            </Button>
                        </>
                    )}

                    {variant === "video-portal" && (
                        <Button
                            colorScheme="green"
                            size="sm"
                            fontWeight="bold"
                            onClick={onClick}
                        >
                            Access Video Guides
                        </Button>
                    )}

                    {variant === "video-single" && (
                        <Button
                            colorScheme="green"
                            size="sm"
                            fontWeight="bold"
                            onClick={onClick}
                        >
                            Watch Video
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    );
}
